import { inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { filter, map, switchMap, tap } from 'rxjs';
import { ROUTE } from '../../models';
import { CanActivateFn, Router } from '@angular/router';
import { getContracts, getContractsActionState, LoadContracts } from '@resident-nx/shared';
import { LocalStorageService } from '@resident-nx/web/data-access';

export const DashboardPageGuard: CanActivateFn = () => {
  const store = inject(Store);
  const router = inject(Router);
  const localStorageService = inject(LocalStorageService);
  return store.select(getContractsActionState).pipe(
    tap(state => {
      if (!state.pending && !state.done) {
        store.dispatch(LoadContracts({}));
      }
    }),
    filter(state => state.done),
    switchMap(() =>
      store.select(getContracts).pipe(
        map(contracts => {
          const hideWelcomeScreen = localStorageService.getItem('hideWelcomeScreen');
          if (!contracts?.length && hideWelcomeScreen) {
            router.navigate([ROUTE.NEWS]);
            return false;
          }

          return true;
        })
      )
    )
  );
};
